import { LogOutIcon, MonitorIcon, MoonIcon, SettingsIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/auth-provider";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { initials } from "@/lib/utils";

const THEMES = [
	{ id: "light", label: "Light", icon: SunIcon },
	{ id: "dark", label: "Dark", icon: MoonIcon },
	{ id: "system", label: "System", icon: MonitorIcon },
] as const;

export function UserMenu() {
	const { user, logout } = useAuth();
	const { theme, setTheme } = useTheme();
	const navigate = useNavigate();
	if (!user) return null;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				className="flex size-7 items-center justify-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
				aria-label="Account menu"
			>
				<Avatar>
					{user.avatarUrl && <AvatarImage src={user.avatarUrl} alt="" />}
					<AvatarFallback>{initials(user.name)}</AvatarFallback>
				</Avatar>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" side="top" className="w-56">
				<div className="px-2 py-1.5">
					<div className="truncate text-[13px] font-medium">{user.name}</div>
					<div className="truncate text-xs text-muted-foreground">{user.email}</div>
				</div>
				<DropdownMenuSeparator />
				<DropdownMenuItem onSelect={() => navigate("/settings")}>
					<SettingsIcon />
					Settings
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuLabel>Theme</DropdownMenuLabel>
				{THEMES.map(({ id, label, icon: Icon }) => (
					<DropdownMenuCheckboxItem key={id} checked={theme === id} onSelect={() => setTheme(id)}>
						<Icon className="size-4 text-muted-foreground" />
						{label}
					</DropdownMenuCheckboxItem>
				))}
				<DropdownMenuSeparator />
				<DropdownMenuItem onSelect={() => void logout()}>
					<LogOutIcon />
					Log out
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
